import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

import TRANSLATIONS_EN from './translations/en/translation.json';
import TRANSLATIONS_DE from './translations/de/translation.json';
const detectionOptions = {
  order: ['localStorage'],
};

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en: {
      translation: TRANSLATIONS_EN,
    },
    de: {
      translation: TRANSLATIONS_DE,
    },
  },
});

i18n.use(LanguageDetector).init({
  detection: detectionOptions,
});

export default i18n;
